import React, {Component} from 'react';
import PropTypes from 'prop-types';
import shouldPureComponentUpdate from 'react-pure-render/function';
import {PinStyle} from './PinStyle.js';

export default class Pin extends Component {
  static propTypes = {
    text: PropTypes.string
  };
  static defaultProps = {};
  shouldComponentUpdate = shouldPureComponentUpdate;
  render() {
    return (
       <div style={PinStyle}>
          {this.props.text}
       </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pin.jsx